import React from 'react';
import { OPT_OUT_LABELS } from '../api/campaigns';
import type { ClientRow } from '../api/clients';
import './MarketingOptOutBadge.css';

interface Props {
  client: Pick<ClientRow, 'marketing_opt_out_reason' | 'marketing_opt_out_at'> | null | undefined;
  /** A short label without the date, for table rows and cards where space is tight. */
  compact?: boolean;
}

const SHORT_TITLES: Record<NonNullable<ClientRow['marketing_opt_out_reason']>, string> = {
  unsubscribed: 'Unsubscribed',
  bounced: 'Email bounced',
  manual: 'Opted out',
};

const TITLES: Record<NonNullable<ClientRow['marketing_opt_out_reason']>, string> = {
  unsubscribed: 'Unsubscribed from marketing',
  bounced: 'Marketing email bounced',
  manual: 'Removed from marketing',
};

/** Explains why this contact is left out of campaigns; renders nothing for everyone else. */
const MarketingOptOutBadge: React.FC<Props> = ({ client, compact = false }) => {
  const reason = client?.marketing_opt_out_reason;
  if (!reason) return null;
  const when = client?.marketing_opt_out_at ? new Date(client.marketing_opt_out_at) : null;
  const date = when && !Number.isNaN(when.getTime()) ? when.toLocaleDateString() : '';
  return (
    <span
      className="marketing-opt-out-badge"
      title={`${OPT_OUT_LABELS[reason]}${date ? ` on ${date}` : ''}. Campaigns skip this address.`}
    >
      {compact ? SHORT_TITLES[reason] : TITLES[reason]}
      {!compact && date ? ` · ${date}` : ''}
    </span>
  );
};

export default MarketingOptOutBadge;
